import { useEffect } from "react";
import { AppLayout } from "@amzn/awsui-components-react/polaris";
import { PAGE_TITLES } from "src/app/constants";
import SideMenu from "src/components/sideMenu/SideMenu";
import FormStudioView from "src/views/admin/formStudio/FormStudioView";

const FormStudioPage = () => {
  useEffect(() => {
    document.title = PAGE_TITLES.FORM_STUDIO;
  }, []);
  return (
    <AppLayout
      content={<FormStudioView />}
      navigation={<SideMenu />}
      toolsHide={true}
      contentType="default"
      footerSelector="#app-footer"
      headerSelector="#app-header"
      ariaLabels={{
        navigationClose: "Close side menu",
        navigationToggle: "Open Side menu",
      }}
    />
  );
};
export default FormStudioPage;
